/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  CarrierAccountOption,
  CarrierProBlockAccountInput,
  CarrierProBlockInput,
  CarrierProBlockReplacement,
  CarrierProBlockSummary,
} from "../models/index";
import {
  CarrierAccountOptionFromJSON,
  CarrierAccountOptionToJSON,
  CarrierProBlockAccountInputFromJSON,
  CarrierProBlockAccountInputToJSON,
  CarrierProBlockInputFromJSON,
  CarrierProBlockInputToJSON,
  CarrierProBlockReplacementFromJSON,
  CarrierProBlockReplacementToJSON,
  CarrierProBlockSummaryFromJSON,
  CarrierProBlockSummaryToJSON,
} from "../models/index";

export interface DeleteCarrierProBlockRequest {
  carrierProBlockId: string;
}

export interface GetCarrierAccountsRequest {
  carrierIdentifier: string;
}

export interface InsertCarrierProBlockRequest {
  carrierProBlockInput: CarrierProBlockInput;
}

export interface ReplaceCarrierProBlockRequest {
  carrierProBlockReplacement: CarrierProBlockReplacement;
}

export interface SetCarrierProBlockAccountRequest {
  carrierProBlockAccountInput: CarrierProBlockAccountInput;
}

/**
 *
 */
export class CarrierProBlockApi extends runtime.BaseAPI {
  /**
   */
  async deleteCarrierProBlockRaw(
    requestParameters: DeleteCarrierProBlockRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierProBlockId"] == null) {
      throw new runtime.RequiredError(
        "carrierProBlockId",
        'Required parameter "carrierProBlockId" was null or undefined when calling deleteCarrierProBlock().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierProBlockId"] != null) {
      queryParameters["carrierProBlockId"] =
        requestParameters["carrierProBlockId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-pro-block/delete-carrier-pro-block`,
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async deleteCarrierProBlock(
    requestParameters: DeleteCarrierProBlockRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteCarrierProBlockRaw(requestParameters, initOverrides);
  }

  /**
   */
  async getAllProBlocksRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CarrierProBlockSummary>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-pro-block/get-all-carrier-pro-block`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CarrierProBlockSummaryFromJSON),
    );
  }

  /**
   */
  async getAllProBlocks(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CarrierProBlockSummary>> {
    const response = await this.getAllProBlocksRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async getCarrierAccountsRaw(
    requestParameters: GetCarrierAccountsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CarrierAccountOption>>> {
    if (requestParameters["carrierIdentifier"] == null) {
      throw new runtime.RequiredError(
        "carrierIdentifier",
        'Required parameter "carrierIdentifier" was null or undefined when calling getCarrierAccounts().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierIdentifier"] != null) {
      queryParameters["carrierIdentifier"] =
        requestParameters["carrierIdentifier"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-pro-block/get-carrier-accounts`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CarrierAccountOptionFromJSON),
    );
  }

  /**
   */
  async getCarrierAccounts(
    requestParameters: GetCarrierAccountsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CarrierAccountOption>> {
    const response = await this.getCarrierAccountsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async insertCarrierProBlockRaw(
    requestParameters: InsertCarrierProBlockRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters["carrierProBlockInput"] == null) {
      throw new runtime.RequiredError(
        "carrierProBlockInput",
        'Required parameter "carrierProBlockInput" was null or undefined when calling insertCarrierProBlock().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/carrier-pro-block/insert-carrier-pro-block`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CarrierProBlockInputToJSON(
          requestParameters["carrierProBlockInput"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   */
  async insertCarrierProBlock(
    requestParameters: InsertCarrierProBlockRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.insertCarrierProBlockRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async replaceCarrierProBlockRaw(
    requestParameters: ReplaceCarrierProBlockRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters["carrierProBlockReplacement"] == null) {
      throw new runtime.RequiredError(
        "carrierProBlockReplacement",
        'Required parameter "carrierProBlockReplacement" was null or undefined when calling replaceCarrierProBlock().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/carrier-pro-block/replace-carrier-pro-block`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CarrierProBlockReplacementToJSON(
          requestParameters["carrierProBlockReplacement"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   */
  async replaceCarrierProBlock(
    requestParameters: ReplaceCarrierProBlockRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.replaceCarrierProBlockRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async setCarrierProBlockAccountRaw(
    requestParameters: SetCarrierProBlockAccountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters["carrierProBlockAccountInput"] == null) {
      throw new runtime.RequiredError(
        "carrierProBlockAccountInput",
        'Required parameter "carrierProBlockAccountInput" was null or undefined when calling setCarrierProBlockAccount().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/carrier-pro-block/set-carrier-pro-block-account`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CarrierProBlockAccountInputToJSON(
          requestParameters["carrierProBlockAccountInput"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   */
  async setCarrierProBlockAccount(
    requestParameters: SetCarrierProBlockAccountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.setCarrierProBlockAccountRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
